import { gql } from '@apollo/client';
const ADD_TENANT_BRAND = gql `
  mutation AddTenantBrand($tenantId: ID!, $name: String!) {
    addBrand(tenantId: $tenantId, name: $name) {
      brand {
        id
        name
      }
    }
  }
`;
export default ADD_TENANT_BRAND;
